import {
  TARGET_TYPE,
  formatTargetScopeKey,
  parseTargetScopeKey,
} from '../../utils/target-scope.utils';
import { mergeKeyedRecords } from './merge-strategies';

export function migrateLegacyTargetScopeKey(key: string): string {
  if (parseTargetScopeKey(key)) {
    return key;
  }

  if (!key.includes(':')) {
    return formatTargetScopeKey({
      targetId: key,
      targetType: TARGET_TYPE.WEB_APPLICATION,
    });
  }

  return key;
}

export function migrateTabScopedStoreKey(scopeKey: string): string {
  return scopeKey.startsWith('applicationId_')
    ? scopeKey.replace(/^applicationId_/, 'targetId_')
    : scopeKey;
}

export function mergeLegacyTargetScopeObjectRecords<
  T extends Record<string, unknown>,
>(records: Record<string, T>): Record<string, T> {
  return mergeKeyedRecords({
    records,
    migrateKey: migrateLegacyTargetScopeKey,
    merge: { type: 'object' },
  });
}

export function mergeLegacyTargetScopeNumberRecords(
  records: Record<string, number>,
): Record<string, number> {
  return mergeKeyedRecords({
    records,
    migrateKey: migrateLegacyTargetScopeKey,
    merge: { type: 'maxNumber' },
  });
}
